import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';

/**
 * Shared visibility for the "contact me from nonprofit" checkbox.
 * Show only when the petition has an owner organization and FCM sign_form_npo_contact_consent is enabled.
 */
export function useShareInfoWithOrganizationVisible(): boolean {
	const { data } = usePetitionDetailsPageData();
	const isNpoClaim = data.petition.organization?.source === 'NPO_CLAIM';
	const fcmEnabled = data.featureConfigs.signFormNpoContactConsentEnabled;
	return isNpoClaim && fcmEnabled;
}
